var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.48 32.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6eebd0;\n      }\n\n      .cls-2 {\n        fill: #715ff5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16.24,
    cy: 16.24,
    r: 16.24
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.91,21.85c-.28,0-.51-.23-.51-.51V8.18c0-.14,.04-.29,.15-.4,.19-.19,.51-.2,.71-.02h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s6.42,6.43,6.42,6.43c.2,.2,.2,.53,0,.73s-.53,.2-.73,0l-5.55-5.55v11.95c0,.28-.23,.51-.51,.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.57,10.63c.28,0,.51,.23,.51,.51v13.16c0,.14-.04,.29-.15,.4-.19,.19-.51,.2-.71,.02h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0s-6.42-6.43-6.42-6.43c-.2-.2-.2-.53,0-.73s.53-.2,.73,0l5.55,5.55V11.14c0-.28,.23-.51,.51-.51Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchSwap);
export default __webpack_public_path__ + "static/media/switchSwap.ae28c2ddf88ca0774c85156f6764ffb5.svg";
export { ForwardRef as ReactComponent };